import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { NewZone } from '../types'

export const createGroup = async (body: NewZone) => {
  const response = await axios.post(`${getAPIService}/groups`, body)
  return response.data
}
